var map = {
	"./weapon-1-selected.png": "0b27",
	"./weapon-2-selected.png": "8e90",
	"./weapon-3-selected.png": "71b1",
	"./weapon-4-selected.png": "2ab3",
	"./weapon-5-selected.png": "67ff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "56a1";